import { FC, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { isMobile } from '@ux-lab-web/shared/libs/tools';

const Home: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const uid = searchParams.get('uid') || '';
    const locationUid = searchParams.get('location_uid') || '';

    if (!!uid) {
      // 带uid参数，重定向到观看端
      const typePath = isMobile() ? 'm' : 'pc';
      window.location.replace(`${window.location.origin}/receiver/${typePath}?uid=${uid}`);
    } else if (!!locationUid) {
      // 带location_uid参数，重定向到全局推流
      const { search } = window.location;
      navigate(`/global-v2${search}`, { replace: true });
    } else {
      // 不带任何参数，重定向到控制台
      window.location.replace(`${window.location.origin}/console/`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default Home;
